module.exports = __webpack_public_path__ + "static/media/pers-1.e532ad74.jpg";